/**
 * "Has this customer seen the first-run intro?" — persisted per shop in `localStorage`.
 *
 * Deliberately NOT `sessionStorage` (which the auth store uses precisely because it forgets on tab
 * close): the intro must stay dismissed across visits, or it stops being a first-run dialog. Keyed by
 * shop so a customer meeting a second brand's trade-in gets a genuine first time again.
 *
 * Guarded like `store/auth.ts`: a browser with storage blocked (private mode / blocked cookies)
 * degrades to "show it every time" rather than crashing the flow.
 */
const KEY_PREFIX = 'ti.introSeen.'

const key = (shopId: string): string => `${KEY_PREFIX}${shopId}`

export function hasSeenIntro(shopId: string | null): boolean {
  if (!shopId) return false
  try {
    return localStorage.getItem(key(shopId)) === 'true'
  } catch {
    return false
  }
}

export function markIntroSeen(shopId: string | null): void {
  if (!shopId) return
  try {
    localStorage.setItem(key(shopId), 'true')
  } catch {
    /* storage unavailable — the intro will simply show again next visit */
  }
}
